import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import {
	ArrayInput,
	BooleanInput,
	Edit,
	ImageField,
	ImageInput,
	NumberInput,
	SimpleForm,
	SimpleFormIterator,
	TextInput,
} from 'react-admin';

const LifestyleAreaEdit = () => {
	return (
		<Edit>
			<SimpleForm>
				<Grid spacing={2} container>
					<Grid item sm={4}>
						<TextInput source="title.he" fullWidth label="כותרת (עברית)" />
					</Grid>
					<Grid item sm={4}>
						<TextInput source="title.en" fullWidth label="כותרת (אנגלית)" />
					</Grid>
					<Grid item sm={2}>
						<BooleanInput source="active" label="פעיל" />
					</Grid>
					<Grid item sm={2}>
						<BooleanInput source="is_tall" label="גבוה" />
					</Grid>
					<Box width="100%" />
					<Grid item sm={4}>
						<TextInput source="sub_title.he" fullWidth label="תת כותרת (עברית)" />
					</Grid>
					<Grid item sm={4}>
						<TextInput source="sub_title.en" fullWidth label="תת כותרת (אנגלית)" />
					</Grid>
					<Grid item sm={2}>
						<NumberInput source="order" label="סדר" />
					</Grid>
					<Grid item sm={4}>
						<TextInput source="bg_color" fullWidth label="צבע רקע" />
					</Grid>
					<Box width="100%" />
					<Grid item sm={12}>
						<ImageInput source="image" label="תמונה">
							<ImageField source="src" />
						</ImageInput>
					</Grid>
					<Grid item sm={12}>
						<ImageInput source="bg_image" label="תמונת רקע">
							<ImageField source="src" />
						</ImageInput>
					</Grid>
					<Grid item sm={12}>
						<ArrayInput source="videos" label="סרטונים" fullWidth>
							<SimpleFormIterator fullWidth>
								<TextInput source="url" label="URL סרטון" fullWidth />
								<TextInput source="image" label="תמונה" fullWidth />
								<TextInput source="title.he" label="כותרת (עברית)" fullWidth />
								<TextInput source="title.en" label="כותרת (אנגלית)" fullWidth />
								<TextInput source="sub_title.he" label="תת כותרת (עברית)" fullWidth />
								<TextInput source="sub_title.en" label="תת כותרת (אנגלית)" fullWidth />
							</SimpleFormIterator>
						</ArrayInput>
					</Grid>
				</Grid>
			</SimpleForm>
		</Edit>
	);
};

export default LifestyleAreaEdit;

